import { render, staticRenderFns } from "./DiscountBadge.vue?vue&type=template&id=43655fe2&scoped=true"
import script from "./DiscountBadge.vue?vue&type=script&lang=ts"
export * from "./DiscountBadge.vue?vue&type=script&lang=ts"
import style0 from "./DiscountBadge.vue?vue&type=style&index=0&id=43655fe2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43655fe2",
  null
  
)

export default component.exports